import axios from 'axios'

const instance = axios.create({ baseURL: 'https://api.onitsoft.com' })

export type ContactFormPayload = {
  name: string
  email: string
  phone?: string
  subject: string
  message: string
}

export const sendContactRequest = (key: string, data: ContactFormPayload) =>
  instance.post(`/contact/${key}`, data)
